export default __webpack_public_path__ + "static/media/count_download.8e704abd.svg";